import $ from 'jquery';
import 'slick-carousel';

class ModalCarousel {
  constructor(element){
    this.$el = $(element);
    this.$modal = $('#weq-modal');
    this.$carouselWrapper = $('<div class="carousel-wrapper weq-modal-content"></div>');
    // this.heading = this.$el.parent().parent().find('.info .heading').text();
    this.slickOptions = {
      arrows:true,
      infinite:true,
      nextArrow: '<div class="carousel-arrow carousel-arrow-next icon-right"></div>',
      prevArrow: '<div class="carousel-arrow carousel-arrow-prev icon-left"></div>',
      dots: true,
      slidesToShow:1,
      slidesToScroll:1,
      waitForAnimate:false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            arrows:false,
          }
        }
      ]
    };
    this.modalSlickOptions = this.slickOptions;
    this.modalSlickOptions.centerMode = 'true';
    this.centerPadding = '8.3vw';

    this.$modal.addClass('weq-modal-carousel');
    this.modalContent = this.$el.siblings('.slides').slick('unslick').clone();

    this.$el.siblings('.slides').slick(this.slickOptions);
    this.makeCarousel();
  }

  makeCarousel() {
    this.$modal.find('.weq-modal-content').replaceWith(this.$carouselWrapper.append(this.modalContent));
    this.modalContent.slick(this.modalSlickOptions);
  }
}

export default ModalCarousel;
